import { useRef, useState } from "react";
import { IconColorE, IconSizeE } from "../../../../models/enums";
import Icon from "../../../../components/Icon/Icon";
import { useCopyText } from "../../../../utils/helpers/copyText";

import styles from "./styles.module.scss";

interface CopyIconI {
  inputName: string;
}

const TIMEOUT_MS = 2000;

const CopyIcon = ({ inputName }: CopyIconI) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);
  const copyText = useCopyText();
  
  const handleCopy = () => {
    clearTimeout(timer.current);

    const valueForCopy = getInputValue(inputName);

    if (valueForCopy) {
      copyText(valueForCopy);
      setCopied(true);

      timer.current = setTimeout(() => {
        setCopied(false);
      }, TIMEOUT_MS);
    }
  };

  return (
    <div className={styles.copyIcon}>
      <Icon
        name={copied ? "approved" : "copy"}
        color={copied ? undefined : IconColorE.BLUE}
        size={IconSizeE.S}
        onClick={handleCopy}
        title="Copy"
      />
    </div>
  );
};

const getInputValue = (inputName: string) => {
  let res;

  const input: HTMLInputElement = document.querySelector(
    `input[name=${inputName}]`
  );

  if (input) {
    res = input.value;
  }

  return res;
};

export default CopyIcon;
